import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-password-reset-success',
  templateUrl: './password-reset-success.component.html'
})
export class PasswordResetSuccessComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
